export const unregisteredUser = (email) => {
  return new Error(`${email} is not a registered user`);
};

export const serverError = () => {
  return new Error(`Server is currently inactive please try again later`);
};
